import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { TranslatePipe } from '@core/i18n-legacy';
import { DividerComponent, IconComponent } from '@core/user-interface-legacy';

import { CreditCardIconPipe } from './credit-card-icon.pipe';

@Component({
  selector: 'rt-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, DividerComponent, TranslatePipe, MomentModule, CreditCardIconPipe],
})
export class CreditCardComponent {
  @Input() public cardType: string;
  @Input() public cardLast4Digits: string;
  @Input() public cardExpirationDate: string;
  @Input() public expiresI18NKey: string = 'app.pricing.billing_page.credit_card_expires';
}
